import React from 'react';
import { shape, string } from 'prop-types';

import './SurveyJobInformation.scss';

class SurveyJobInformation extends React.PureComponent {
  static propTypes = {
    metadata: shape({
      surveyCode: string,
      surveyTitle: string,
      jobScope: string,
      jobTitle: string
    })
  };

  render() {
    const { metadata } = this.props;
    return (
      <div className="survey-job-match-info">
        <p className="survey-job-match__title pxl-text-body">{metadata.jobTitle}</p>
        <p className="survey-job-match__subtitle pxl-text-small">
          {metadata.surveyCode} {metadata.surveyTitle}
        </p>
        <p className="survey-job-match__subtitle pxl-text-small">{metadata.jobScope}</p>
      </div>
    );
  }
}

export default SurveyJobInformation;
